var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmptyStateEntry,{attrs:{"title":_vm.$t('trainings.manage-empty'),"text":_vm.$t('trainings.manage-empty-description'),"image-src":"/images/empty-manage-courses.svg"},scopedSlots:_vm._u([{key:"button",fn:function(){return [_c(_setup.CreateCourseButton,{attrs:{"with-plus-icon":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }